import React from "react";
import styles from "./prev-arrow.module.css";
import PrevArrowSvg from "./PrevArrowSvg";

const PrevArrow = ({ handler }) => {
  return (
    <div className={styles.buttonContainer}>
      <button onClick={handler} className={styles.prevButton}>
        <PrevArrowSvg />
      </button>
    </div>
  );
};

export default PrevArrow;
